import { ApexOptions } from 'apexcharts'
import { FC, useMemo } from 'react'
import Chart from 'react-apexcharts'
import { baseChartOptions, CHART_FONT, formatAxisNumber, INK, INK_MUTED, mergeOptions, SURFACE } from './charts/chartTheme'

interface IDonutChart {
    labels: string[]
    values: number[]
    unit?: string
    totalLabel?: string
}

export const DonutChart: FC<IDonutChart> = ({ labels, values, unit = '', totalLabel = '總數' }) => {
    const options = useMemo<ApexOptions>(() => mergeOptions(baseChartOptions, {
        labels,
        legend: { show: false },
        stroke: { width: 2, colors: [SURFACE] },
        plotOptions: {
            pie: {
                donut: {
                    size: '68%',
                    labels: {
                        show: true,
                        name: { show: true, fontSize: '13px', fontFamily: CHART_FONT, color: INK_MUTED, offsetY: 20 },
                        value: {
                            show: true, fontSize: '26px', fontFamily: CHART_FONT, fontWeight: 600, color: INK, offsetY: -14,
                            formatter: (value: string) => formatAxisNumber(Number(value)),
                        },
                        total: {
                            show: true, label: totalLabel, fontSize: '13px', fontFamily: CHART_FONT, color: INK_MUTED,
                            formatter: () => formatAxisNumber(values.reduce((a, b) => a + b, 0)),
                        },
                    },
                },
            },
        },
        tooltip: { y: { formatter: (value: number) => `${formatAxisNumber(value)} ${unit}`.trim() } },
    }), [labels, values, unit, totalLabel])

    return <Chart options={options} series={values} type='donut' width='100%' height='100%' />
}
